import { Building2 } from 'lucide-react';

import { EmptyState } from '@/ui/EmptyState';

/**
 * O estado que explica a lacuna, para quem não é SME.
 *
 * O painel compara diretorias: quem está parado, quem foi cobrado, quantos lotes
 * cada uma mandou. A SME olha todas; uma DRE olha a sua. Só que **não há como
 * saber qual é a dela**: `UsuarioAutenticado` (`nucleo/auth/tipos.ts`, o contrato
 * real do `GET /eu`) não tem campo de diretoria, e inventar a correspondência no
 * mock criaria no front uma noção de escopo que a API real não tem.
 *
 * Então, em vez de mostrar as treze diretorias a quem deveria ver uma, a seção
 * mantém a estrutura e diz o que falta — mesmo tratamento da coluna `Saúde` da
 * Parametrização (CLAUDE.md, "Regras de interface", item 7): a estrutura fica, a
 * afirmação que ninguém apurou não.
 */

export const TITULO_SEM_RECORTE_POR_DRE = 'Sem recorte por diretoria';

export const FRASE_SEM_RECORTE_POR_DRE =
  'Esta lista compara diretorias, e o sistema ainda não sabe de qual diretoria é ' +
  'quem está olhando: o recorte depende de uma rota que ainda não existe. Até lá, ' +
  'ela aparece apenas para a SME.';

export function SemRecortePorDre() {
  return (
    <EmptyState
      icon={Building2}
      title={TITULO_SEM_RECORTE_POR_DRE}
      description={FRASE_SEM_RECORTE_POR_DRE}
    />
  );
}
